import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { Badge } from '@common/badge';
import styles from '@common/badge/specialized-badges/specialized-badges.css';
export function EnabledBadge() {
    return (_jsx(Badge, { className: classNames(styles.badge, styles.primary), color: Badge.color.Primary, size: Badge.size.Md, variant: Badge.variant.Filled, ...assignTestId('constituent-enabled-badge'), children: "Enabled" }));
}
